import React from "react";

import { Button, Form, Grid, Input, theme, Typography } from "antd";
import { useUser } from "../../contexts/UserContext";

import { ArrowLeftOutlined, MailOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import ErrorList from "./ErrorList";
import { t } from "i18next";
import { forgetPassword } from "../../redux/ForgetPassword/action";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const FrogetPasswordForm = ({ handleForgetPassword }) => {

    let lang = localStorage.getItem("lang")


    const errors = useSelector((state) => state.signInErrorMessage)


    const { token } = useToken();
    const screens = useBreakpoint();
    const { userConfigs } = useUser();
    const dispatch = useDispatch()


    const onFinish = (values) => {
        dispatch(forgetPassword(values))
    };


    const handleBack = () => {
        handleForgetPassword(false)
    };

    const styles = {
        container: {
            margin: "0 auto",
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: "380px"
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: "center",
            width: "100%",
        },
        forgotPassword: {
            float: "right"
        },
        header: {
            marginBottom: token.marginXL,
            display: "flex",
            alignItems: "center",
        },
        section: {
            alignItems: "center",
            backgroundColor: userConfigs.dark ? 'transparent' : 'white',
            display: "flex",
            height: "auto",
            width: '100%',
            padding: '0px'

        },
        text: {
            color: token.colorTextSecondary
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3
        }
    };

    return (
        <section style={styles.section} dir={userConfigs.locale.locale === 'fa' || userConfigs.locale.locale === 'ar' ? 'rtl' : 'ltr'}>
            <div style={styles.container}>
                <div style={styles.header}>
                    {
                        lang === 'fa' || lang === 'ar' ?
                            <ArrowLeftOutlined style={{ fontSize: '20px', cursor: 'pointer', marginLeft: '10px', marginTop: '8px' , rotate:'180deg' }} onClick={handleBack} />
                            :
                            <ArrowLeftOutlined style={{ fontSize: '20px', cursor: 'pointer', marginRight: '10px', marginTop: '8px' }} onClick={handleBack} />

                    }
                    <Title style={styles.title}>{t('user.forget_password_title')}</Title>
                </div>
                <Form
                    name="normal_login"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    layout="vertical"
                    requiredMark="optional"
                >
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Please input your Email!",
                            },
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder={t('user.email')}
                            style={{ padding: '10px' }}
                            autoComplete="new-email"
                        />
                    </Form.Item>
                    {
                        errors &&
                        <ErrorList errors={errors} />
                    }
                    <Form.Item style={{ marginBottom: "0px" }}>
                        <Button block="true" type="primary" htmlType="submit">
                            {t('user.reset_password')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </section>
    )
}

export default FrogetPasswordForm
